import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, KeyRound } from 'lucide-react';
import { aiVisibilityService } from '../../../services/aiVisibilityService';

// Until there is a Stripe checkout, the full report is unlocked with an
// invitation code. The report is generated for the free check just shown.
const AccessCodeForm = ({ checkId, website }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState('');
  const [site, setSite] = useState(website || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  if (!checkId) return null;

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 text-sm font-semibold text-[var(--lp-muted)] transition-colors hover:text-[var(--lp-text)]"
      >
        <KeyRound size={16} aria-hidden="true" />
        ¿Tienes un código de invitación?
      </button>
    );
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!code.trim()) {
      setError('Escribe tu código de invitación.');
      return;
    }
    setLoading(true);
    setError(null);
    const result = await aiVisibilityService.redeemReport({
      checkId,
      accessCode: code.trim(),
      website: site.trim() || undefined
    });
    if (result.success) {
      navigate(`/informe/${result.reportId}`);
    } else {
      setLoading(false);
      setError(result.message);
    }
  };

  return (
    <form onSubmit={handleSubmit} noValidate className="max-w-xl rounded-[22px] border border-[var(--lp-line)] p-5 sm:p-6">
      <p className="flex items-center gap-2 font-semibold">
        <KeyRound size={18} className="text-[var(--lp-lime)]" aria-hidden="true" />
        Canjea tu código de invitación
      </p>
      <p className="mt-1 text-sm text-[var(--lp-muted)]">
        Genera el informe completo de este negocio. Tarda un par de minutos.
      </p>

      <div className="mt-5 grid gap-4 sm:grid-cols-2">
        <div>
          <label htmlFor="access-code" className="text-xs font-semibold text-[var(--lp-muted)]">
            Código
          </label>
          <input
            id="access-code"
            name="access-code"
            className="lp-field lp-mono mt-2 uppercase"
            placeholder="WS-XXXX-XXXX"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            autoComplete="off"
            autoCapitalize="characters"
            spellCheck="false"
            required
          />
        </div>
        <div>
          <label htmlFor="access-website" className="text-xs font-semibold text-[var(--lp-muted)]">
            Tu web (opcional, la revisamos también)
          </label>
          <input
            id="access-website"
            name="access-website"
            type="url"
            inputMode="url"
            className="lp-field mt-2"
            placeholder="tuweb.com"
            value={site}
            onChange={(e) => setSite(e.target.value)}
            autoComplete="url"
          />
        </div>
      </div>

      <button type="submit" className="lp-btn mt-6" disabled={loading}>
        {loading ? 'Empezando…' : 'Generar mi informe'}
        <ArrowRight size={20} strokeWidth={2.6} aria-hidden="true" />
      </button>

      {error && (
        <p role="alert" className="mt-4 text-sm font-medium text-[var(--lp-alarm)]">
          {error}
        </p>
      )}
    </form>
  );
};

export default AccessCodeForm;
